<template>
  <main role="main">

    <div class="container" id="registerAdministration">

      <div class="row mb-5">

        <div class="col-md-12 p-0 m-0">
          <b-button variant="primary" class="float-right" @click="$router.push({name: 'RegisterAuditLog'})">Revizijska
            sled šifrantov
          </b-button>
          <div class="clear clearfix"></div>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-md-12">
          <div class="tab">

            <button class="tab" @click="changeIsEdit(true)" :class="{active: showEditable}">Šifranti (urejanje)
            </button>
            <button class="tab" @click="changeIsEdit(false)" :class="{active: !showEditable}">Šifranti (samo prikaz)
            </button>
          </div>
          <div class="tab-content">
            <vue-good-table
                styleClass="vgt-table table table-hover table-striped"
                :columns="columns"
                :rows="showEditable ? rows : rows2"
                :key="tableKey"
                @on-row-click="onRowClick"

            >
              <div slot="emptystate">
                <div class="text-center"><i class="fa fa-exclamation-triangle"></i>
                  <em>{{ $t('text.globals.noData') }}</em></div>
              </div>
            </vue-good-table>
          </div>

          <b-modal
              centered
              size="xl"
              id="modal-register-list"
              :title="registerName"
              ref="modal-register-list"
              :no-close-on-esc="true"
              :no-close-on-backdrop="true"
          >

            <b-container class="mb-4">
              <b-row>
                <b-col>

                  <loading
                      :active.sync="isLoadingCrudEdit"
                      :can-cancel="false"
                      :is-full-page="true"
                  ></loading>

                  <a class="btn btn-primary text-white mb-3"
                     v-if="crudEditableRegisterItems.includes(registerName) && !addNewEntryMode"
                     @click="addItemToRegister(registerName, registerColumns)"><i class="fa fa-plus"></i> Dodaj nov vnos</a>

                  <div class="card" v-if="addNewEntryMode">
                    <div class="card-body bg-light">
                      <h5>Dodajanje zapisa v šifrant {{ registerName }}</h5>
                      <RegisterEntry ref="registerEntry" :registerColumns="registerColumns" :registerName="registerName"
                                     @crudRegisterEntry="updateCrudRegisterEntry"
                                     @addNewItemFormValidation="updateAddNewItemFormValidation"></RegisterEntry>

                      <div class="d-flex mt-4">
                        <a class="btn btn-secondary text-white mb-3"
                           v-if="crudEditableRegisterItems.includes(registerName)"
                           @click="() => { addNewEntryMode = false; crudRegisterEntry = {}; }"><i
                            class="fa fa-times"></i> Prekliči</a>
                        <b-button class="btn btn-success text-white mb-3 mr-0 ml-auto"
                                  :disabled="addNewItemFormHasErrors"
                                  v-if="crudEditableRegisterItems.includes(registerName)"
                                  @click="saveNewItemToRegister()"><i class="fa fa-plus"></i> Dodaj nov vnos
                        </b-button>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>


            <b-container>
<!--              {{registerColumns}}<br/><br/>{{registerOptions}}-->
              <vue-good-table
                  styleClass="vgt-table table table-hover table-striped"
                  :columns="registerColumns"
                  :rows="registerOptions"
                  @on-row-click="editField"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'active'">
                    {{ props.formattedRow[props.column.field] ? 'aktiven' : 'neaktiven' }}
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>

              </vue-good-table>
            </b-container>

            <div slot="modal-footer" class="w-100">
              <b-button id="previousButton1" variant="secondary" class="float-left mr-0"
                        @click="() => { $bvModal.hide('modal-register-list'); addNewEntryMode = false; }">
                {{ $t('text.globals.close') }}
              </b-button>
<!--              <b-button id="saveButton1" variant="primary" class="float-right mr-0"-->
<!--                        @click="() => { $bvModal.hide('modal-register-list'); addNewEntryMode = false; }">-->
<!--                {{ $t('text.globals.accept') }}-->
<!--              </b-button>-->
            </div>
          </b-modal>


          <b-modal
              centered
              size="xl"
              id="modal-register-option-edit"
              title="Urejanje"
              ref="modal-register-option-edit"
              :no-close-on-esc="true"
              :no-close-on-backdrop="true">

            <!--            <b-container>-->
            <!--              <label for="description">Opis</label>-->
            <!--              <input type="textarea" class="form-control" id="description" v-model="selectedRegisterOption.description"-->
            <!--                     @input="validateDescriptionEdit"-->
            <!--                     :class="{'is-invalid': errorObject.descriptionError}"-->

            <!--              ></input>-->
            <!--              <div-->
            <!--                  class="invalid-feedback"-->
            <!--                  v-if="errorObject.descriptionError"-->
            <!--                  style="font-size: 1rem"-->
            <!--              >-->
            <!--                {{ $t("text.documentDetailsEdit.fieldShouldNotBeEmpty") }}-->
            <!--              </div>-->


            <!--              <div v-if="registerName === 'VRSTA DOKUMENTA' || registerName === 'IZVOR GRADIVA' || registerName === 'MESTO HRAMBE' || registerName === 'STOPNJA ZAUPNOSTI' || registerName === 'UPORABNIKI VPISNIKOV'">-->

            <!--                <b-row>-->
            <!--                  <b-col lg="4" class="mt-3">-->
            <!--                    <label for="activeFrom">Aktiven OD</label>-->
            <!--                    <VueCtkDateTimePicker :id="'activeFrom'" format="YYYY-MM-DDTHH:mm:ss.SS"-->
            <!--                                          :label="'Aktiven OD'"-->
            <!--                                          :locale="$t('text.globals.datePickerLocale')"-->
            <!--                                          :noLabel="true"-->
            <!--                                          :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"-->
            <!--                                          :range="false"-->
            <!--                                          :auto-close="true"-->
            <!--                                          formatted="DD.MM.YYYY"-->
            <!--                                          v-model="selectedRegisterOption.activeFrom"-->
            <!--                                          :max-date="selectedRegisterOption.activeTo ? moment(selectedRegisterOption.activeTo).startOf('day').subtract(1, 'days').format() : ''"-->
            <!--                                          :no-button-now="true"-->
            <!--                                          :only-date="true"-->
            <!--                    />-->
            <!--                  </b-col>-->
            <!--                </b-row>-->
            <!--                <b-row>-->
            <!--                  <b-col lg="4" class="mt-3">-->
            <!--                    <label for="activenTo">Aktiven DO</label>-->
            <!--                    <VueCtkDateTimePicker :id="'activenTo'" format="YYYY-MM-DDTHH:mm:ss.SS"-->
            <!--                                          :label="'Aktiven DO'"-->
            <!--                                          :locale="$t('text.globals.datePickerLocale')"-->
            <!--                                          :noLabel="true"-->
            <!--                                          :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"-->
            <!--                                          :range="false"-->
            <!--                                          :auto-close="true"-->
            <!--                                          formatted="DD.MM.YYYY"-->
            <!--                                          v-model="selectedRegisterOption.activeTo"-->
            <!--                                          :min-date="selectedRegisterOption.activeFrom ? moment(selectedRegisterOption.activeFrom).startOf('day').add(1, 'days').format() : ''"-->
            <!--                                          :no-button-now="true"-->
            <!--                                          :only-date="true"-->
            <!--                    />-->
            <!--                  </b-col>-->
            <!--                </b-row>-->
            <!--              </div>-->
            <!--              <div class="mt-3">-->
            <!--                <label for="active">Aktiven<br/>-->
            <!--                  <input type="checkbox" id="active" v-model="selectedRegisterOption.active" disabled></input>-->
            <!--                </label>-->

            <!--              </div>-->

            <!--              <b-alert variant="warning" :show="selectedRegisterOption.inUse">-->
            <!--                <i class="fa fa-exclamation-triangle pr-2"></i> Šifrant "{{selectedRegisterOption.description}}" je v uporabi, zato ga ni dovoljeno brisati.-->
            <!--              </b-alert>-->
            <!--            </b-container>-->
            <b-container>

              <div v-for="(item, index) in registerColumns" :key="'item_' + index" v-if="item.field !== 'active'">
                <b-form-group
                    class="mb-2"
                    :id="'formGroup_' + index"
                    :label="item.label"
                    :label-for="'input_' + index"
                    description=""
                >
                  <template v-if="item.type === 'date'">
                    <b-col lg="4" class="p-0">
                      <VueCtkDateTimePicker :id="'activeFrom'" format="YYYY-MM-DDTHH:mm:ss.SS"
                                            :label="item.label"
                                            :locale="$t('text.globals.datePickerLocale')"
                                            :noLabel="true"
                                            :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"
                                            :range="false"
                                            :auto-close="true"
                                            formatted="DD.MM.YYYY"
                                            v-model="selectedRegisterOption[item.field]"
                                            :max-date="item.field === 'activeFrom' && selectedRegisterOption['activeTo'] ? moment(selectedRegisterOption['activeTo']).startOf('day').subtract(1, 'days').format() : ''"
                                            :min-date="item.field === 'activeTo' && selectedRegisterOption['activeFrom'] ? moment(selectedRegisterOption['activeFrom']).startOf('day').add(1, 'days').format() : ''"
                                            :no-button-now="true"
                                            :only-date="true"
                                            :class="{'is-invalid': errorObject[item.field]}"
                                            :required="item.field === 'activeFrom'"
                                            @input="validateDescriptionEdit(item)"
                                            :button-now-translation="$t('text.globals.now')"
                      />

                      <div
                          class="invalid-feedback"
                          v-if="errorObject[item.field]"
                          style="font-size: 1rem"
                      >
                        {{ $t("text.documentDetailsEdit.fieldShouldNotBeEmpty") }}
                      </div>

                    </b-col>
                  </template>

                  <template v-else-if="item.type === 'boolean'">
                    <b-form-checkbox v-model="selectedRegisterOption[item.field]"
                                     :id="'input_' + index"
                                     class="position-relative" style="margin-top: -5px" disabled>
                    </b-form-checkbox>
                  </template>

                  <template v-else>
                    <b-form-input
                        :id="'input_' + index"
                        :type="item.type"
                        :step="item.type === 'number' ? 1 : null"
                        @keydown="(evt) => ['e', 'E', '+', '-'].includes(evt.key) && item.type === 'number' && evt.preventDefault()"
                        v-model="selectedRegisterOption[item.field]"
                        @input="validateDescriptionEdit(item)"
                        :class="{'is-invalid': errorObject[item.field]}"
                        :placeholder="'vnesi ' +  item.label"
                        :disabled="item.field === 'id'"
                    ></b-form-input>
                    <div
                        class="invalid-feedback"
                        v-if="errorObject[item.field]"
                        style="font-size: 1rem"
                    >
                      {{ $t("text.documentDetailsEdit.fieldShouldNotBeEmpty") }}
                    </div>
                  </template>
                </b-form-group>
              </div>

              <div v-if="registerName === 'UPORABNIKI VPISNIKOV' || registerName === 'VRSTA DOKUMENTA'">
                <div class="form-group">
                  <label for="povezaniSistemi2">{{ $t('text.classificationPlanMetadata.connectedSystems') }}</label>

                  <a class="btn btn-sm btn-link float-right text-info mt-2" @click="selectAllConnectedSystems"
                     v-if="selectedRegisterOption.connectedSystems && povezaniSistemi && selectedRegisterOption.connectedSystems.length < povezaniSistemi.length">{{$t('text.classificationPlanEntry.registryModal.selectAll')}}</a>
                  <a class="btn btn-sm btn-link float-right text-info mt-2" @click="deselectAllConnectedSystems"
                     v-if="selectedRegisterOption.connectedSystems && povezaniSistemi && selectedRegisterOption.connectedSystems.length >= povezaniSistemi.length">Odstrani vse</a>

                  <v-select
                      class="form-control"
                      id="povezaniSistemi2"
                      name="povezaniSistemi2"
                      label="description"
                      :options="povezaniSistemi"
                      :reduce="item => item.id"
                      v-model="selectedRegisterOption.connectedSystems"
                      :multiple="registerName === 'VRSTA DOKUMENTA' ? true : false"
                  >
                    <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                  </v-select>
                </div>
              </div>

              <b-alert variant="warning" :show="selectedRegisterOption.inUse">
                <i class="fa fa-exclamation-triangle pr-2"></i> Zapis
                "{{ selectedRegisterOption.description || selectedRegisterOption.username }}" je v
                uporabi, zato ga ni dovoljeno brisati.
              </b-alert>
            </b-container>

            <div slot="modal-footer" class="w-100">
              <b-button id="previousButton" variant="secondary" class="float-left mr-0"
                        @click="$bvModal.hide('modal-register-option-edit'); ">
                {{ $t('text.globals.back') }}
              </b-button>
              <div class="float-right">
                <b-button id="registerOptionSaveButton mr-1" variant="danger" class="mr-2"
                          @click="deleteRegisterOption();"
                          :disabled="selectedRegisterOption.inUse || isNotDeletable(selectedRegisterOption.id)">
                  <i class="fa fa-trash"></i> {{ $t('text.globals.delete') }}
                </b-button>

                <b-button id="registerOptionSaveButton" variant="primary" class="mr-0"
                          @click="updateRegisterOption();"
                          :disabled="!_.isEmpty(errorObject)"
                >
                  <i class="fa fa-save"></i> {{ $t('text.globals.accept') }}
                </b-button>
              </div>

            </div>
          </b-modal>

          <b-modal
              centered
              size="lg"
              id="modal-error-register-update"
              title="Napaka pri posodabljanju sifranta"
              :hide-header-close="true"
          >
            <b-container>
              Polja niso ustrezno izpolnjena!
            </b-container>

            <div slot="modal-footer" class="w-100">
              <b-button
                  id="previousButton3"
                  variant="secondary"
                  class="float-right mr-0"
                  @click="$bvModal.hide('modal-error-register-update')"
              >
                {{ $t("text.globals.back") }}
              </b-button>
            </div>
          </b-modal>


          <b-modal
              centered
              size="lg"
              id="modal-edit-success"
              :hide-header-close="true"
              title="Opozorilo"
          >
            <b-container>
              Šifrant posodobljen!
            </b-container>

            <div slot="modal-footer" class="w-100">
              <b-button
                  id="modal-edit-success-previous"
                  variant="secondary"
                  class="float-right mr-0"
                  @click="$bvModal.hide('modal-edit-success')"
              >
                {{ $t("text.globals.back") }}
              </b-button>
            </div>
          </b-modal>


        </div>
      </div>
    </div>
  </main>
</template>

<script>

import axios from 'axios/index';
import RegisterEntry from "../components/RegisterEntry";
import Loading from "vue-loading-overlay";
import swal from "sweetalert2";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: "RegisterAdministration",
  components: {
    RegisterEntry,
    Loading,
    vSelect
  },
  data() {
    return {
      addNewEntryMode: false,
      isLoadingCrudEdit: false,
      crudRegisterEntry: {},
      columns: [
        {
          label: "Naziv",
          field: 'name',
          type: 'text',
        },

      ],
      rows: [
        //{id: 1, name: "KONČNA ODLOČITEV PREGLEDANE ENOTE GRADIVA"},
        {id: 2, name: "IZVOR GRADIVA"},
        // editing is not possible for document format { id:3, name:"OBLIKA DOKUMENTA"},
        //{id: 4, name: "OZNAKA VELJAVNOSTI PODPISA"},
        //{id: 5, name: "RAZLOG UNIČENJA"},
        //{id: 6, name: "STATUS DOKUMENTA"},
        {id: 7, name: "MESTO HRAMBE"},
        //{id: 8, name: "POROČILA"},
        //{id: 9, name: "PROGRAMSKA OPREMA ZA PRETVORBO"},
        //{id: 10, name: "ROK HRAMBE"},
        //{id: 11, name: "STATUS PREGLEDANE ENOTE GRADIVA"},
        //{id: 12, name: "STATUS PRETVORBE"},
        {id: 13, name: "STOPNJA ZAUPNOSTI"},
        //{id: 14, name: "TIP DOKUMENTA"},
        {id: 15, name: "UPORABNIKI VPISNIKOV"},
        {id: 16, name: "VRSTA DOKUMENTA"}
      ],

      rows2: [
        {id: 1, name: "DOVOLJENJA"},
        {id: 2, name: "MIMETYPE"},
        // editing is not possible for document format { id:3, name:"OBLIKA DOKUMENTA"},
        {id: 4, name: "METAPODATKI"},
        {id: 5, name: "POVEZAN SISTEM"},
        {id: 6, name: "REVIZIJSKA SLED"},
        {id: 7, name: "SODIŠČE"},
        {id: 8, name: "VPISNIK"},
        {id: 9, name: "KONČNA ODLOČITEV PREGLEDANE ENOTE GRADIVA"},
        {id: 10, name: "OZNAKA VELJAVNOSTI PODPISA"},
        {id: 11, name: "RAZLOG UNIČENJA"},
        {id: 12, name: "STATUS DOKUMENTA"},
        {id: 13, name: "POROČILA"},
        {id: 14, name: "PROGRAMSKA OPREMA ZA PRETVORBO"},
        {id: 15, name: "ROK HRAMBE"},
        {id: 16, name: "STATUS PREGLEDANE ENOTE GRADIVA"},
        {id: 17, name: "STATUS PRETVORBE"},
        {id: 18, name: "TIP DOKUMENTA"}
      ],

      crudEditableRegisterItems: [
        "IZVOR GRADIVA",
        "MESTO HRAMBE",
        "STOPNJA ZAUPNOSTI",
        "UPORABNIKI VPISNIKOV",
        "VRSTA DOKUMENTA"
      ],

      tableKey: 0,
      registerColumns: [
        {
          label: "ID",
          field: "id",
          type: 'number',
          hidden: false
        },
        {
          label: "Naziv",
          field: 'code',
          type: 'text',
          hidden: false
        },
        {
          label: "Opis",
          field: "description",
          type: 'text',
        }
      ],
      registerOptions: [],
      registerName: "",
      registerDescriptionToEdit: "",
      api: "documentReviewDecision",
      selectedRegisterOption: {
        description: "",
        active: null,
        activeFrom: null,
        activeTo: null
      },
      errorObject: {},
      showEditable: true,
      selectedRegister: "",
      povezaniSistemi: [],
      addNewItemFormHasErrors: true
    }
  },

  computed: {
    isNotDeletable() {
      return id => {
        return (this.registerName === 'IZVOR GRADIVA' && id === 1) || (this.registerName === 'MESTO HRAMBE' && (id === 1 || id === 2));
      }
    }
  },

  async mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAllDropdownOptions");

    Promise.all([p1]).then((values) => {
      this.povezaniSistemi = this.$store.getters.getConnectedSystemsOptions.filter((item) => item.ehramba);
    });
  },

  methods: {

    onRowClick(params) {
      this.setApi(params);
      this.setRegisterColumns(params);
      this.registerName = params.row.name;
      console.log(params);
      axios.get(config.codeLists + this.api)
          .then((res) => {
            console.log("axios successful");
            if (params.row.name != "DOVOLJENJA") {
              this.registerOptions = res.data.body;
            } else {
              this.registerOptions = res.data.body.roles[0].permissions;
            }
            // this.registerOptions = this.registerOptions.splice(6,1);
            console.log(this.registerOptions);
            this.$refs["modal-register-list"].show();

            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
    },

    editField(params) {
      const _this = this;
      if (this.showEditable) {
        this.selectedRegisterOption = _.cloneDeep(params.row);

        this.errorObject = {}
        console.log(params);
        this.registerDescriptionToEdit = this.selectedRegisterOption.description;

        if(_this.registerName === "UPORABNIKI VPISNIKOV") {
          this.selectedRegisterOption.connectedSystems = params.row.connectedSystemId;
        }

        // fix for getting array with one element with empty string if no connected system is selected
        if(this.selectedRegisterOption.connectedSystems && this.selectedRegisterOption.connectedSystems.length > 0 && this.selectedRegisterOption.connectedSystems[0] === "") {
          this.selectedRegisterOption.connectedSystems = [];
        }

        // TODO: this should be done generically in the future
        //if (_this.registerName === 'VRSTA DOKUMENTA') {
        if (!_this.isNotDeletable(_this.selectedRegisterOption.id) && _this.registerName !== "UPORABNIKI VPISNIKOV")
          this.checkIfRegisterOptionIsInUse(_this.registerName);
        //  }



        this.$refs['modal-register-option-edit'].show();
      }
    },

    checkIfRegisterOptionIsInUse(registerName) {
      const _this = this;

      let property;
      if (registerName === 'IZVOR GRADIVA')
        property = 'EH:izvor_gradiva';
      else if (registerName === 'VRSTA DOKUMENTA')
        property = 'EH:vrsta_gradiva';
      else if (registerName === 'STOPNJA ZAUPNOSTI')
        property = 'EH:stopnja_zaupnosti';
      else if (registerName === 'MESTO HRAMBE')
        property = 'EH:mesto_hrambe';

      let data = {
        //"property": "EH:vrsta_gradiva",
        "property": property,
        "valueLong": _this.selectedRegisterOption.id
      };

      axios.post(config.rootEhramba + 'checkInUseForGui', data)
          .then((res) => {
            console.log(res.data.inUse);

            _this.selectedRegisterOption.inUse = res.data.inUse;
            _this.$forceUpdate();

          })
          .catch((error) => {
            console.error(error);
          })

    },

    validateDescriptionEdit(item) {
      // activeTo should not be validated
      if(item.field === 'activeTo') {
        return;
      }

      let value = "";
      if(item.type === 'number') {
        this.selectedRegisterOption[item.field] = this.selectedRegisterOption[item.field] ? this.selectedRegisterOption[item.field].toString().replace(/[^\d]/g, '') : null;
        value = this.selectedRegisterOption[item.field];
      } else {
        value = this.selectedRegisterOption[item.field] ? this.selectedRegisterOption[item.field].trim() : this.selectedRegisterOption[item.field];
      }

      if (value && value.length > 0) {
        delete this.errorObject[item.field];

        if(item.field === 'externalSuvpId') {
          delete this.errorObject['externalEvipId'];
        } else if(item.field === 'externalEvipId') {
          delete this.errorObject['externalSuvpId'];
        }

      } else {
        if((item.field === 'externalSuvpId' && this.selectedRegisterOption['externalEvipId'] !== null && this.selectedRegisterOption['externalEvipId'] !== '') || (item.field === 'externalEvipId' && this.selectedRegisterOption['externalSuvpId'] !== null && this.selectedRegisterOption['externalSuvpId'] !== '')) {
          delete this.errorObject['externalSuvpId'];
          delete this.errorObject['externalEvipId'];
        } else {
          this.errorObject[item.field] = true;
        }

        // if(item.field === 'externalSuvpId' && (!this.selectedRegisterOption['externalEvipId'] || this.selectedRegisterOption['externalEvipId'].length === 0)) {
        //   this.errorObject['externalEvipId'] = true;
        // } else if(item.field === 'externalEvipId' && (!this.selectedRegisterOption['externalSuvpId'] || this.selectedRegisterOption['externalSuvpId'].length === 0)) {
        //   this.errorObject['externalSuvpId'] = true;
        // }
      }
    },

    updateRegisterOption() {
      const _this = this;

      _this.selectedRegisterOption.activeFrom ? _this.selectedRegisterOption.activeFrom = moment(this.selectedRegisterOption.activeFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]') : '';
      _this.selectedRegisterOption.activeTo ? _this.selectedRegisterOption.activeTo = moment(this.selectedRegisterOption.activeTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]') : '';

      let data = this.selectedRegisterOption;

      if (_this.registerName === 'UPORABNIKI VPISNIKOV') {
        data.connectedSystemId = data.connectedSystems;
      }

      data.externalSuvpId = data.externalSuvpId === '' ? null : data.externalSuvpId;
      data.externalEvipId = data.externalEvipId === '' ? null : data.externalEvipId;

      if (Object.values(this.errorObject).every(item => !item)) {
        axios.post(config.codeLists + this.api + '/' + this.selectedRegisterOption.id, data)
            .then((res) => {
              console.log(res);
              let thisRow = {
                row: {
                  name: this.registerName
                }
              }
              _this.onRowClick(thisRow);
              this.$bvModal.hide('modal-register-option-edit');
              this.$bvModal.show('modal-edit-success');
            })
            .catch((error) => {
              console.error(error);

              // this.$swal(
              //     this.$t('text.globals.error'),
              //     "Prišlo je do napake!",
              //     {dangerMode: true}
              // );
            })
      } else {
        this.$bvModal.show('modal-error-register-update');
      }
    },

    deleteRegisterOption() {
      const _this = this;
      let data = this.selectedRegisterOption;

      _this.$swal({
        title: 'Ali ste prepričani, da želite izbrisati vnos z opisom ' + data.description + '?',
        text: 'Po potrditvi bo vsebina vnosa trajno izbrisana.',
        dangerMode: true,
        allowEscapeKey: true,
        buttons: {
          cancel: {
            text: this.$t('text.globals.cancel'),
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: this.$t('text.globals.delete'),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
      })
          .then((result) => {
            console.log("result", result);
            if (!result) {

            } else if (result) {

              axios.delete(config.codeLists + this.api + '/' + this.selectedRegisterOption.id)
                  .then((res) => {
                    console.log(res);
                    _this.$bvModal.hide('modal-register-option-edit');
                    _this.$bvModal.show('modal-edit-success');
                    let thisRow = {
                      row: {
                        name: this.registerName
                      }
                    }
                    _this.onRowClick(thisRow);
                  })
                  .catch((error) => {
                    console.error(error);
                    // _this.$swal(
                    //     _this.$t('text.globals.error'),
                    //     "Prišlo je do napake!",
                    //     {dangerMode: true}
                    // );
                  })

            }
          });


    },

    changeIsEdit(param) {
      this.showEditable = param;
    },

    addItemToRegister(registerName, registerColumns) {
      const _this = this;

      _this.addNewEntryMode = true;
      console.log("registerName", registerName);
      console.log("registerColumns", registerColumns);
    },

    saveNewItemToRegister() {
      const _this = this;

      _.each(_this.registerColumns, function (item){
        _this.$refs.registerEntry.validateDescriptionEdit(item);
      });

      _this.crudRegisterEntry.activeFrom ? _this.crudRegisterEntry.activeFrom = moment(this.crudRegisterEntry.activeFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]') : '';
      _this.crudRegisterEntry.activeTo ? _this.crudRegisterEntry.activeTo = moment(this.crudRegisterEntry.activeTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]') : '';

      if (typeof _this.crudRegisterEntry.active === 'undefined') {
        _this.crudRegisterEntry.active = false;
      }

      if (_this.registerName === 'UPORABNIKI VPISNIKOV') {
        _this.crudRegisterEntry.connectedSystemId = _this.crudRegisterEntry.connectedSystems;
      }
      console.log("_this.crudRegisterEntry", _this.crudRegisterEntry);
      console.log("selectedRegister", _this.selectedRegister);

      if ((typeof _this.crudRegisterEntry.description === 'undefined' && typeof _this.crudRegisterEntry.username === 'undefined') || (_this.crudRegisterEntry.description === '' && _this.crudRegisterEntry.username === '')) {
        this.$bvModal.show('modal-error-register-update');
        return;
      } else {
        _this.isLoadingCrudEdit = true;

        axios.post(config.codeLists + this.api + '/new', _this.crudRegisterEntry)
            .then((res) => {
              console.log(res);

              _this.addNewEntryMode = false;
              _this.isLoadingCrudEdit = false;
              _this.crudRegisterEntry = {};

              _this.isLoadingCrudEdit = false;
              _this.$bvModal.show('modal-edit-success');
              let thisRow = {
                row: {
                  name: this.registerName
                }
              }
              _this.onRowClick(thisRow);
            })
            .catch((error) => {
              console.error(error);
              _this.isLoadingCrudEdit = false;
              // _this.$swal(
              //     _this.$t('text.globals.error'),
              //     "Prišlo je do napake!",
              //     {dangerMode: true}
              // );
            })

      }


    },

    updateCrudRegisterEntry(val) {
      console.log("HERE", val);
      this.crudRegisterEntry = val;
    },

    updateAddNewItemFormValidation(val) {
      this.addNewItemFormHasErrors = !_.isEmpty(val);
    },

    formatDate(value) {
      if (value)
        return moment(value).utc().format('DD.MM.YYYY');
      return '/';
    },

    sortFn(val1, val2) {
      return (new Date(val1) < new Date(val2) ? -1 : (new Date(val1) > new Date(val2) ? 1 : 0));
    },

    selectAllConnectedSystems() {
      const _this = this;
      _this.selectedRegisterOption.connectedSystems = _this.povezaniSistemi.map(val => val.id);
    },

    deselectAllConnectedSystems() {
      const _this = this;
      _this.selectedRegisterOption.connectedSystems = [];
    },

    setRegisterColumns(params) {
      let name = params.row.name;
      switch (name) {
        case "IZVOR GRADIVA":
        case "MESTO HRAMBE":
        case "STOPNJA ZAUPNOSTI":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Opis",
              field: "description",
              type: 'text',
            },
            {
              label: "Aktiven OD",
              field: "activeFrom",
              type: "date",
              formatFn: this.formatDate,
              sortable: true,
              sortFn: this.sortFn
            },
            {
              label: "Aktiven DO",
              field: "activeTo",
              type: "date",
              formatFn: this.formatDate,
              sortable: true,
              sortFn: this.sortFn
            },
            {
              label: "Aktivnost",
              field: "active",
              type: "boolean"
            },
          ];
          break;
        case "VRSTA DOKUMENTA":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "SU šifra",
              field: "externalSuvpId",
              type: "number"
            },
            {
              label: "EVIP šifra",
              field: "externalEvipId",
              type: "number"
            },
            {
              label: "Opis",
              field: "description",
              type: 'text',
            },
            {
              label: "Komentar",
              field: "longDescription",
              type: 'text',
            },
            {
              label: "Aktiven OD",
              field: "activeFrom",
              type: "date",
              formatFn: this.formatDate
            },
            {
              label: "Aktiven DO",
              field: "activeTo",
              type: "date",
              formatFn: this.formatDate
            },
            {
              label: "Aktivnost",
              field: "active",
              type: "boolean"
            },
          ];
          break;

        case "POVEZAN SISTEM":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Opis",
              field: "description",
              type: 'text',
            },
            {
              label: "Ehramba",
              field: "ehramba",
              type: 'boolean',
            },
            {
              label: "RM",
              field: "ehramba",
              type: 'boolean',
            }
          ];
          break;

        case "VPISNIK":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Kratek naziv",
              field: "shortName",
              type: 'text',
            },
            {
              label: "Opis",
              field: "description",
              type: 'text',
            },
            {
              label: "Oddelek",
              field: "department",
              type: 'text',
            },
            {
              label: "Povezan sistem",
              field: "connectedSystem",
              type: 'text',
            }
          ];
          break;

        case "SODIŠČE":
        case "OZNAKA VELJAVNOSTI PODPISA":
        case "RAZLOG UNIČENJA":
        case "STATUS DOKUMENTA":
        case "PROGRAMSKA OPREMA ZA PRETVORBO":
        case "STATUS PREGLEDANE ENOTE GRADIVA":
        case "STATUS PRETVORBE":
        case "TIP DOKUMENTA":
        case "KONČNA ODLOČITEV PREGLEDANE ENOTE GRADIVA":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Opis",
              field: "description",
              type: 'text',
            }
          ];
          break;

        case "POROČILA":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Naziv",
              field: "name",
              type: "text"
            },
            {
              label: "Opis",
              field: "description",
              type: 'text',
            },
          ];
          break;
        case "MIMETYPE":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Mimetype",
              field: "mimetype",
              type: "text"
            },
            {
              label: "Vrsta",
              field: "documentFormat.description",
              type: "text"
            }
          ];
          break;
        case "ROK HRAMBE":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Opis",
              field: "explanation",
              type: 'text',
            },
            {
              label: "Tip",
              field: "type",
              type: "text"
            },
          ];
          break;
        case "METAPODATKI":
          this.registerColumns = [
            {
              label: "Polje",
              field: "label",
              type: 'text',
            },
            {
              label: "Naziv",
              field: "name",
              type: "text"
            }
          ];
          break;
        case "REVIZIJSKA SLED":
          this.registerColumns = [
            {
              label: "Vrednost",
              field: "value",
              type: 'text',
            },
            {
              label: "Ključ",
              field: "key",
              type: "text"
            }
          ];
          break;
        case "DOVOLJENJA":
          this.registerColumns = [
            {
              label: "Naziv",
              field: "id",
              type: 'text',
            },
            {
              label: "Opis",
              field: "description",
              type: "text"
            }
          ];
          break;
        case "UPORABNIKI VPISNIKOV":
          this.registerColumns = [
            {
              label: "ID",
              field: "id",
              type: 'number',
            },
            {
              label: "Uporabniško ime",
              field: "username",
              type: "text"
            },
            {
              label: "Aktiven OD",
              field: "activeFrom",
              type: "date",
              formatFn: this.formatDate
            },
            {
              label: "Aktiven DO",
              field: "activeTo",
              type: "date",
              formatFn: this.formatDate
            },
            {
              label: "Aktivnost",
              field: "active",
              type: "boolean"
            },
            {
              label: "Alfresco stran",
              field: "alfrescoSite",
              type: "text"
            },
            {
              label: "ID vpisnika",
              field: "registerId",
              type: "text"
            },
          ];
          break;


      }
    },


    setApi(params) {
      console.log(params.row.name);
      let name = params.row.name;
      switch (name) {
        case "KONČNA ODLOČITEV PREGLEDANE ENOTE GRADIVA":
          this.api = "documentReviewDecision";
          break;
        case "IZVOR GRADIVA":
          this.api = "document-source";
          break;
        case "OBLIKA DOKUMENTA":
          this.api = "document-format";
          break;
        case "OZNAKA VELJAVNOSTI PODPISA":
          this.api = "signature-validity";
          break;
        case "STATUS DOKUMENTA":
          this.api = "document-status";
          break;
        case "RAZLOG UNIČENJA":
          this.api = "documentDestroyReason";
          break;
        case "MESTO HRAMBE":
          this.api = "storage-place";
          break;
        case "POROČILA":
          this.api = 'report';
          break;
        case "PROGRAMSKA OPREMA ZA PRETVORBO":
          this.api = 'conversion-software';
          break;
        case "ROK HRAMBE":
          this.api = 'storage-date';
          break;
        case "STATUS PREGLEDANE ENOTE GRADIVA":
          this.api = "documentReviewStatus";
          break;
        case "STATUS PRETVORBE":
          this.api = "conversion-status";
          break;
        case "STOPNJA ZAUPNOSTI":
          this.api = "confidentiality";
          break;
        case "TIP DOKUMENTA":
          this.api = "document-mode";
          break;
        case "UPORABNIKI VPISNIKOV":
          this.api = "register-users";
          break;
        case "VRSTA DOKUMENTA":
          this.api = "document-type";
          break;
        case "DOVOLJENJA":
          this.api = "permissions";
          break;

        case "MIMETYPE":
          this.api = "mimetype";
          break;

        case "METAPODATKI":
          this.api = "properties";
          break;
        case "POVEZAN SISTEM":
          this.api = "connected-system";
          break;
        case "REVIZIJSKA SLED":
          this.api = "audit-dictionary";
          break;
        case "SODIŠČE":
          this.api = "court";
          break;
        case "VPISNIK":
          this.api = "register";
          break;


      }
      return;

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/RegisterAdministration.vue